import React from 'react';
import PropTypes from 'prop-types';
import format from 'date-fns/format';
import { getMilliSecondsTimestamp } from 'utils/dateUtils';

import s from './ReadableTimeStamp.scss';

const ReadableTimeStamp = ({ timestamp, updateDate }) => {
  let lstUpdTimeStamp;
  if (!timestamp && updateDate) {
    lstUpdTimeStamp = new Date(updateDate).getTime();
  }
  const validTimestamp = getMilliSecondsTimestamp(timestamp || lstUpdTimeStamp);
  const date = new Date(validTimestamp);
  const timestamp2 =
    validTimestamp + date.getTimezoneOffset() * 60 * 1000 + 330 * 60 * 1000;
  const readableTime = format(timestamp2, 'HH:mm [(IST)] MMM DD');
  const seoDate = format(validTimestamp, 'YYYY-MM-DDTHH:mm:ss+05:30');

  return (
    <>
      {(timestamp || lstUpdTimeStamp) && readableTime ? (
        <div className={s.timestamp}>
          {readableTime}
          <time dateTime={seoDate} />
          <meta content={seoDate} />
        </div>
      ) : null}
    </>
  );
};

ReadableTimeStamp.propTypes = {
  timestamp: PropTypes.number,
  updateDate: PropTypes.number,
};

ReadableTimeStamp.defaultProps = {
  timestamp: 0,
  updateDate: 0,
};

export default ReadableTimeStamp;
